export type QueryFilterValue = string | number | boolean | null | undefined;

export type QueryFilters = Record<string, QueryFilterValue>;

/**
 * Build a `URLSearchParams` from a filter object, dropping entries whose value is
 * `null`, `undefined`, or an empty string. The backend treats `""` as a real
 * filter value, so empty params must never reach the wire.
 *
 * @param filters - Key/value pairs to turn into query params.
 * @returns A `URLSearchParams` with only the meaningful entries, each stringified.
 */
export const buildQueryParams = (filters: QueryFilters = {}): URLSearchParams =>
  new URLSearchParams(
    Object.entries(filters ?? {}).reduce<[string, string][]>((acc, [key, value]) => {
      if (value != null && value !== "") {
        acc.push([key, String(value)]);
      }
      return acc;
    }, []),
  );
